import { render, staticRenderFns } from "./tuodan_pay_h5.vue?vue&type=template&id=1bec1161&scoped=true&"
import script from "./tuodan_pay_h5.vue?vue&type=script&lang=js&"
export * from "./tuodan_pay_h5.vue?vue&type=script&lang=js&"
import style0 from "./tuodan_pay_h5.vue?vue&type=style&index=0&id=1bec1161&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec1161",
  null
  
)

export default component.exports